// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"MainHeader_mainHeader__yxN2p","secondaryHeader":"MainHeader_secondaryHeader__7379l"};